/* =========================================================
   INSPO Product Page Animations
   For inquiry-only collector product pages
   Requires GSAP + ScrollTrigger
   Runs only on .inspo-product-kowloon
   ========================================================= */

(function () {
  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var page = document.querySelector(".inspo-product-kowloon");

    if (!page) return;

    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var isMobile = window.matchMedia("(max-width: 900px)").matches;

    page.classList.add("inspo-product-js-ready");

    /* -----------------------------------------------------
       Autoplay product videos safely
    ----------------------------------------------------- */

    var productVideos = page.querySelectorAll("video");

    productVideos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
    });

    var videoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.18
      }
    );

    productVideos.forEach(function (video) {
      videoObserver.observe(video);
    });

    /* -----------------------------------------------------
       If GSAP is unavailable, stop here safely
    ----------------------------------------------------- */

    if (prefersReducedMotion || !window.gsap || !window.ScrollTrigger) {
      page.classList.add("inspo-product-motion-basic");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    /* -----------------------------------------------------
       Scroll progress indicator
    ----------------------------------------------------- */

    var progress = document.createElement("div");
    progress.className = "inspo-product-scroll-progress";
    document.body.appendChild(progress);

    gsap.to(progress, {
      scaleX: 1,
      ease: "none",
      scrollTrigger: {
        trigger: page,
        start: "top top",
        end: "bottom bottom",
        scrub: 0.2
      }
    });

    /* -----------------------------------------------------
       Opening cinematic hero entrance
    ----------------------------------------------------- */

    var opening = gsap.timeline({
      defaults: {
        ease: "power3.out"
      }
    });

    opening
      .fromTo(
        ".inspo-product-hero-media img, .inspo-product-hero-media video",
        {
          scale: 1.1,
          opacity: 0
        },
        {
          scale: 1,
          opacity: 1,
          duration: 1.35
        }
      )
      .fromTo(
        ".inspo-product-hero .inspo-kicker",
        {
          y: 24,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.72
        },
        "-=0.8"
      )
      .fromTo(
        ".inspo-product-hero-title",
        {
          y: 48,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 1
        },
        "-=0.52"
      )
      .fromTo(
        ".inspo-product-hero-subheading",
        {
          y: 24,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.76
        },
        "-=0.55"
      )
      .fromTo(
        ".inspo-product-hero-actions, .inspo-product-hero-meta",
        {
          y: 18,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.72,
          stagger: 0.12
        },
        "-=0.42"
      );

    /* -----------------------------------------------------
       Desktop: pinned hero with scroll zoom
    ----------------------------------------------------- */

    if (!isMobile) {
      var heroTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: ".inspo-product-hero",
          start: "top top",
          end: "+=120%",
          pin: true,
          scrub: 0.8,
          anticipatePin: 1
        }
      });

      heroTimeline
        .to(
          ".inspo-product-hero-media img, .inspo-product-hero-media video",
          {
            scale: 1.16,
            ease: "none"
          },
          0
        )
        .to(
          ".inspo-product-hero-shade",
          {
            opacity: 1,
            ease: "none"
          },
          0
        )
        .to(
          ".inspo-product-hero-content",
          {
            y: 70,
            opacity: 0,
            ease: "none"
          },
          0.18
        );
    }

    /* -----------------------------------------------------
       Global section typography reveal
    ----------------------------------------------------- */

    var revealItems = gsap.utils.toArray([
      ".inspo-product-intro-copy",
      ".inspo-product-showcase-head",
      ".inspo-product-design-head",
      ".inspo-product-specs-head",
      ".inspo-product-final-cta-inner"
    ].join(","));

    revealItems.forEach(function (item) {
      gsap.fromTo(
        item,
        {
          y: 48,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 78%",
            once: true
          }
        }
      );
    });

    /* -----------------------------------------------------
       Parallax media movement
    ----------------------------------------------------- */

    var parallaxItems = gsap.utils.toArray([
      ".inspo-product-intro-media img",
      ".inspo-product-showcase-media img",
      ".inspo-product-gallery-item img"
    ].join(","));

    parallaxItems.forEach(function (item) {
      gsap.fromTo(
        item,
        {
          scale: 1.08,
          yPercent: -4
        },
        {
          scale: 1,
          yPercent: 4,
          ease: "none",
          scrollTrigger: {
            trigger: item.closest("section") || item,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.8
          }
        }
      );
    });

    /* -----------------------------------------------------
       Highlight cards stagger
    ----------------------------------------------------- */

    gsap.fromTo(
      ".inspo-product-highlight",
      {
        y: 42,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.86,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".inspo-product-highlights",
          start: "top 78%",
          once: true
        }
      }
    );

    /* -----------------------------------------------------
       Design cards stagger
    ----------------------------------------------------- */

    gsap.fromTo(
      ".inspo-product-design-card",
      {
        y: 42,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.86,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".inspo-product-design-grid",
          start: "top 78%",
          once: true
        }
      }
    );

    /* -----------------------------------------------------
       Spec row line draw
    ----------------------------------------------------- */

    gsap.utils.toArray(".inspo-product-spec-row").forEach(function (row) {
      gsap.fromTo(
        row,
        {
          "--inspo-spec-line": 0,
          y: 18,
          opacity: 0
        },
        {
          "--inspo-spec-line": 1,
          y: 0,
          opacity: 1,
          duration: 0.78,
          ease: "power3.out",
          scrollTrigger: {
            trigger: row,
            start: "top 86%",
            once: true
          }
        }
      );
    });

    /* -----------------------------------------------------
       Gallery reveal
    ----------------------------------------------------- */

    gsap.fromTo(
      ".inspo-product-gallery-item",
      {
        y: 44,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.95,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".inspo-product-gallery",
          start: "top 78%",
          once: true
        }
      }
    );

    /* -----------------------------------------------------
       Cursor glow on desktop
    ----------------------------------------------------- */

    if (!isMobile) {
      var glowTargets = page.querySelectorAll(".inspo-product-hero, .inspo-product-showcase, .inspo-product-final-cta");

      glowTargets.forEach(function (target) {
        target.addEventListener("mousemove", function (event) {
          var rect = target.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;

          target.style.setProperty("--inspo-cursor-x", x + "%");
          target.style.setProperty("--inspo-cursor-y", y + "%");
        });
      });
    }

    /* -----------------------------------------------------
       Refresh after images load
    ----------------------------------------------------- */

    window.addEventListener("load", function () {
      ScrollTrigger.refresh();
    });
  });
})();